
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeOverlap as ObiPipeOverlapElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-overlap.js';
 
 
 

 
 export const ObiPipeOverlap = createComponent({
   react: React,
   tagName: 'obi-pipe-overlap',
   elementClass: ObiPipeOverlapElement,
   events: {
     
   }
  });
 
 